import {
  FETCH_PATIENTORDER_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PATIENTORDER_SUCCESS_ACTION:
      return {
        ...state,
        patientorederDtlsList: action.payload.rows,
        patientorederDtlsCount: action.payload.count
      };
      
    default:
      return {
        ...state
      };
  }
}
